import { notification } from "antd";

import { SettingApi } from "lib/api";
import { ApiHelper, Http } from "lib/api/base";

import { ListingGroup } from "lib/data/model";


export class ListingGroupApi {
	public static getListingGroups = async (): Promise<ListingGroup[]> => {

		// Get Base Url
		const baseUrl = SettingApi.getApiBaseUrl();

		// Check Base Url
		if (baseUrl) {

			// Configure Url
			const url: string = `${baseUrl}/DataFieldType`;

			// Make Request
			const response: Response = await Http.httpGet(url, undefined);

			// Check Response
			if (response.ok) {

				// Parse Response Body
				const dataFieldTypes: ListingGroup[] = await ApiHelper.parseResponseBody(response);

				return dataFieldTypes;
			}

			// TODO: Handle Errors
		}

		// Return Nothing
		return [];
	}

	public static getListingGroup = async (id: number): Promise<ListingGroup | undefined> => {

		// Get Base Url
		const baseUrl = SettingApi.getApiBaseUrl();

		// Check Base Url
		if (baseUrl) {

			// Configure Url
			const url: string = `${baseUrl}/ListingGroup/${id.toString()}`;

			// Make Request
			const response: Response = await Http.httpGet(url, undefined);

			// Check Response
			if (response.ok) {

				// Parse Response Body
				const dataFieldType: ListingGroup = await ApiHelper.parseResponseBody(response);

				return dataFieldType;
			}

			// TODO: Handle Errors
		}

		// Return Nothing
		return undefined;
	}

	public static saveNewListingGroup = async (listingGroup: ListingGroup): Promise<ListingGroup | undefined> => {

		// Make Request
		const response: Response = await Http.httpPut("ListingGroup", listingGroup);

		if (response && response.ok) {

			const newListingGroup: ListingGroup = await ApiHelper.parseResponseBody(response);

			// Display Error Message
			notification.success({
				message: "Success",
				description: "Record saved successfully."
			});

			return newListingGroup;
		}
		else {

			switch (response.status) {

				case 422: // Unprocessable Entity

					notification.error({
						message: "Validation Failed",
						description: "Please check the form data and try again."
					});

					const validationErrors = await ApiHelper.parseResponseBody(response);
					return validationErrors;

				default:

					notification.error({
						message: "Unknown Error",
						description: "An unknown error has occurred."
					});
			}
		}

		return undefined;
	}
}
